import { connect } from "react-redux"
import { logout } from "../../redux/authReducer"
import Header from "./Header"

const mapStateToProps = (state) => ({
    isLogin: !!state.auth.token
})

export default connect(mapStateToProps, { logout })(Header)